module.exports = __webpack_public_path__ + "static/PragmaticaExtended-Black-ae2ae65cf2756c3f957543bbde3f390b.woff";